import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaterials = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("rect", {
			id: "c",
			x: 0,
			y: 0,
			width: 511,
			height: 439,
			rx: 14
		}),
		/* @__PURE__ */ _jsx("rect", {
			id: "a",
			x: 0,
			y: 0,
			width: 463,
			height: 247,
			rx: 8
		}),
		/* @__PURE__ */ _jsxs("filter", {
			x: "-3.1%",
			y: "-3.2%",
			width: "106.3%",
			height: "107.3%",
			filterUnits: "objectBoundingBox",
			id: "b",
			children: [
				/* @__PURE__ */ _jsx("feOffset", {
					dy: 2,
					in: "SourceAlpha",
					result: "shadowOffsetOuter1"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 5,
					in: "shadowOffsetOuter1",
					result: "shadowBlurOuter1"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
					in: "shadowBlurOuter1"
				})
			]
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "d",
			maskContentUnits: "userSpaceOnUse",
			maskUnits: "objectBoundingBox",
			x: 0,
			y: 0,
			width: 463,
			height: 247,
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#a" })
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFF",
				d: "M-701-323H739v800H-701z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#E4EEF5",
				opacity: .5,
				d: "M-701-323H739V734H-701z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillOpacity: .05,
				fill: "#145466",
				d: "M-701-323H739v800H-701z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(-236 -142)",
				children: [/* @__PURE__ */ _jsx("use", {
					fill: "#000",
					filter: "url(#b)",
					xlinkHref: "#c"
				}), /* @__PURE__ */ _jsx("use", {
					fill: "#FFF",
					xlinkHref: "#c"
				})]
			}),
			/* @__PURE__ */ _jsx("use", {
				mask: "url(#d)",
				xlinkHref: "#a",
				fill: "#FFF",
				stroke: "#CBDCE7",
				strokeDasharray: 5,
				strokeLinecap: "round",
				strokeWidth: 2,
				transform: "translate(-212 -62)"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M0 0h39.891v40H0z" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.243 36.667H6.649A1.664 1.664 0 014.986 35V13.333h29.919V35c0 .92-.744 1.667-1.662 1.667zM34.905 10H4.986V5c0-.92.745-1.667 1.663-1.667h26.594c.918 0 1.662.747 1.662 1.667v5zm-23.27 8.333V25h6.649v-6.667h-6.649zm0 10v3.334h16.621v-3.334H11.635zM21.608 20v3.333h6.648V20h-6.648z",
				fill: "#A7B4C7"
			})
		]
	})]
});
export default SvgMaterials;
